import { SET_LEAD_LOADING, SET_LEAD, SET_PAGE_INFO, SET_AUTH, RESET_FLOW, HIDE_LEAD_LOADING, GO_BACK, SET_STEP_LOADING, HIDE_STEP_LOADING, TOGGLE_MODAL } from '../types'

export default (state, action) => {
    switch (action.type) {


        case SET_AUTH:
            return {
                ...state,
                auth: action.payload
            }
        case SET_LEAD_LOADING:
            return {
                ...state,
                leadLoading: true
            }
        case HIDE_LEAD_LOADING:
            return {
                ...state, leadLoading: false
            }
        case SET_STEP_LOADING:
            return {
                ...state, stepLoading: true
            }
        case HIDE_STEP_LOADING:
            return {
                ...state, stepLoading: false
            }
        case SET_LEAD:
            return {
                ...state,
                lead: action.payload,
                step: action.payload.step,
                leadLoading: false,
                stepLoading: false,
            }
        case GO_BACK:
            return {
                ...state,
                step: action.payload,
                stepLoading: false,
            }

        case RESET_FLOW:
            localStorage.removeItem('lead_token');
            return {
                ...state,
                step: action.payload,
                stepLoading: false,
                leadLoading: false,

            }
        case TOGGLE_MODAL:
            return {
                ...state,
                modal: action.payload,
            }

        case SET_PAGE_INFO:
            const { id, enable_rate_card_equipment, products, enable_rate_card_summary } = action.payload.message.lp;
            const arrayOfObj = Object.entries(products).map((e) => (e[1]));
            return {
                ...state,
                lp: { id, enable_rate_card_equipment, enable_rate_card_summary, products: arrayOfObj },
                leadLoading: false,

            }

        default:
            return state;
    }
}